export const galleryImages = [
  { src: "/ayac/_DSC2580.JPG", alt: "Worship" },
  { src: "/ayac/_DSC2769.JPG", alt: "Community" },
  { src: "/ayac/_DSC2302.JPG", alt: "Praise" },
  { src: "/ayac/_DSC5899.JPG", alt: "Service" },
  { src: "/ayac/DSC_2873.JPG", alt: "Connection" },
  { src: "/ayac/_DSC2160.JPG", alt: "Focus" },
  { src: "/ayac/_DSC2570.JPG", alt: "Power" },
];

export const cultureCardImages = [
  "/ayac/_DSC5899.JPG",
  "/ayac/_DSC2160.JPG",
  "/ayac/_DSC2570.JPG",
];
